import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeLine: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-line"><path fillRule="evenodd" clipRule="evenodd" d="M14.3746 2.22382C12.9933 1.09361 11.0067 1.0936 9.62536 2.22382L4.37536 6.51928C3.50485 7.23151 3 8.29687 3 9.42162V17.25C3 19.321 4.67893 21 6.75 21H17.25C19.3211 21 21 19.321 21 17.25V9.42162C21 8.29687 20.4952 7.23151 19.6246 6.51928L14.3746 2.22382ZM7.75 15.5C7.33579 15.5 7 15.8358 7 16.25C7 16.6642 7.33579 17 7.75 17H16.25C16.6642 17 17 16.6642 17 16.25C17 15.8358 16.6642 15.5 16.25 15.5H7.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHomeLine;
